namespace Gamification.Administration {
    export interface UserListRequest extends Serenity.ListRequest {
    }
}
